import React, { FC, MouseEvent } from 'react'
import cx from 'classnames'
import { Icon } from '@ui'
import { PopoverInteractionKind, Position } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import css from './addFavoriteButton.module.scss'

type PropsT = {
  className?: string
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
  isFavorite: boolean
  couldAddFavorite?: boolean
}

const AddFavoriteButton: FC<React.PropsWithChildren<PropsT>> = ({
  className,
  onClick,
  isFavorite,
  couldAddFavorite = true,
}) => {
  const tooltip = couldAddFavorite
    ? `${isFavorite ? 'Remove from' : 'Add to'} favorite`
    : 'You already have 10 favorite locations'

  return (
    <Tooltip2
      className={cx(css.add_favorite, className)}
      content={tooltip}
      position={Position.TOP}
      interactionKind={PopoverInteractionKind.HOVER_TARGET_ONLY}
    >
      <button data-test="add-favorite-test" disabled={!couldAddFavorite} onClick={onClick}>
        <Icon name="star" className={isFavorite ? 'fas' : ''} />
      </button>
    </Tooltip2>
  )
}

export default AddFavoriteButton
